export const ignoreCodeUaRegoin = [
  '45', '43', '56', '62', '41', '61', '34', '44', '52', '53',
  '64', '33', '32', '51', '48', '53', '36', '54', '35', '31',
  '57', '55', '38', '47', '46', '37',
]
